module.exports = __webpack_public_path__ + "img/logo_navbar.8c559d26.png";